import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModerationService } from './moderation.service';
import { ModerationItem } from './moderation.type';
import { SnackBarService } from '@teammood/shared/ui/snack-bar';


@Component({
    selector: 'moderation',
    templateUrl: './moderation.component.html',
    providers: [ModerationService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModerationComponent implements OnInit {
        
    moderationItems: ModerationItem[];

    constructor(
        private moderationService: ModerationService, 
        private snackbarService: SnackBarService) {
    }

    ngOnInit() {
        this.listModerationRequests();
    }

    private async listModerationRequests() {
        this.moderationItems = await this.moderationService.listModerationRequests()
    }

    async review(item: ModerationItem) {
        try {
            await this.moderationService.review(item)
            this.snackbarService.success("Mood under review");
            this.moderationItems = [];
            this.listModerationRequests();
        }catch(error) {
            this.snackbarService.error(error);
        }
        
    }

    async restore(item: ModerationItem) {

        try {
            await this.moderationService.restore(item)
            this.snackbarService.success("Mood restored");
            this.moderationItems = [];
            this.listModerationRequests();
        }catch(error) {
            this.snackbarService.error(error);
        }
    }

    async moderate(item: ModerationItem) {
        try {
            await this.moderationService.moderate(item)
            this.snackbarService.success("Mood moderated");
            this.moderationItems = [];
            this.listModerationRequests();
        }catch(error) {
            this.snackbarService.error(error);
        }
    }
}
